<template>
  <section class="header-section" >
    <div class="header-section__left">
      <slot name="left">
        <img class="logo-img" src="../../assets/logo.png" alt="">
        <span class="logo">少先队幸福成长课堂</span>
      </slot>
    </div>
    <div class="header-section__right">
      <slot name="right"></slot>
    </div>
    <slot name="default"></slot>
  </section>
</template>

<script>
import util from '@/views/CommonUtil.js'
export default {
  name: 'layoutHeader',
  props: {
    titleAlign: {
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  deactivated () {
  },
  destroyed () {
  },
  created () {
	util.initWebsocket()
  },
  components: {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
  @import "../../assets/style/index";

  @margin-width: 48px;

  .header-section {
    height: @header-height;
    line-height: @header-height;
    position: relative;
    display: flex;
    align-content: center;
    justify-content: space-between;
    background-color: @main-color-2;
    z-index:1000;
    &__left {
      min-width: @header-height;
      display: flex;
      align-items: center;
      width: 370px;
      margin-left: @margin-width;
      .logo-img{
        height: 54px;
        margin-right: 20px;
      }
      .logo {
        font-size: 20px;
        color: #fff;
        font-family: 'PingFangSC-Medium';
      }
    }
    &__right {
      min-width: @header-height;
      margin-right: @margin-width;
      flex: 1;
      float:right;
      width:max-content;
    }
  }
</style>
